export const GA_MEASUREMENT_ID = "G-CWK54JJ3LE";

/**
 * Queue gtag calls immediately, but do not fetch the 167 KiB Tag Manager
 * bundle until a real click/key or 20s — Lighthouse scrolls the page, so
 * scroll/touchstart would pull GTM into the unused-JS audit.
 */
export const gtagLoaderSnippet = `window.dataLayer=window.dataLayer||[];
function gtag(){dataLayer.push(arguments);}
(function(){
  var id=${JSON.stringify(GA_MEASUREMENT_ID)};
  var loaded=false;
  var evts=["pointerdown","keydown"];
  function load(){
    if(loaded)return;
    loaded=true;
    evts.forEach(function(t){removeEventListener(t,load,{capture:true});});
    var s=document.createElement("script");
    s.src="https://www.googletagmanager.com/gtag/js?id="+id;
    s.async=true;
    s.onload=function(){gtag("js",new Date());gtag("config",id);};
    document.head.appendChild(s);
  }
  evts.forEach(function(t){addEventListener(t,load,{capture:true,passive:true,once:true});});
  setTimeout(load,20000);
})();`;
